const title = process.env.VUE_APP_BASE_NAME || '后台管理系统';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}-${title}`;
  }
  return title;
}